import React, {ReactNode} from 'react'
import Form from 'react-bootstrap/Form'

export function StringInput(props: {
  value: string
  setFieldValue: (field: string, value: string) => void
  label: string
  name: string
  placeholder?: string
  info?: ReactNode
}) {
  const {value, setFieldValue, name, placeholder} = props

  const handleOnChange = (value: string) => {
    setFieldValue(name, value)
  }

  return (
    <Form.Group className="mb-3 pb-2">
      <Form.Label>{props.label}</Form.Label>
      <Form.Control
        onChange={(e) => {
          handleOnChange(e.target.value)
        }}
        value={value}
        placeholder={placeholder}
      />
      {props.info}
    </Form.Group>
  )
}
